import React from 'react';
import { Text, Box } from '@wix/design-system';
import { PremiumSmall } from '@wix/wix-ui-icons-common';
import { useEssentials } from '../../contexts/essentials-context';
export function PremiumSiteRequiredBadge({ size = 'tiny', showIcon = true, }) {
    const { t } = useEssentials();
    return (React.createElement(Box, { gap: "2px", verticalAlign: "middle" },
        showIcon && React.createElement(PremiumSmall, null),
        React.createElement(Text, { size: size, weight: "thin", skin: "standard", secondary: true }, t('app.pricing.Premium'))));
}
//# sourceMappingURL=premium-site-required-badge.js.map